<div class="mb-3">
  <div class="bg-custom">
    @if (displayDetails) {
    <div class="container">
      @if (memberInfo) {
      <div>
        <h1 class="section-header">
          {{ "HOUSEHOLD_MEMBER" | globalTranslate }}
        </h1>
        <hr />
        <div>
          <small
            ><strong>{{ "NAME" | globalTranslate }}</strong></small
          >
          @if (isHeadOfHouseHold) {
          <p>
            {{ memberInfo.firstName }} {{ memberInfo.hoHMiddleInitial }}
            {{ memberInfo.lastName }} {{ memberInfo.hoHSuffixName }}
          </p>
          } @if (!isHeadOfHouseHold) {
          <p>
            {{ memberInfo.firstName }} {{ memberInfo.middleInitial }}
            {{ memberInfo.lastName }} {{ memberInfo.suffixName }}
          </p>
          }
        </div>
        <div>
          <small
            ><strong>{{ "PERSON_ID" | globalTranslate }}</strong></small
          >
          <p>{{ memberInfo.indvId }}</p>
        </div>
        <div></div>
      </div>
      }<br />
      @if (coverageInfo) {
      <div>
        <div>
          <h2 class="section-header">
            {{ "COVERAGE_INFO" | globalTranslate }}
          </h2>
        </div>
        <hr />
        @if (coverageInfo.edgStatus === 'AP' && coverageInfo.cobSw !== 'Y') {
        <div>
          <p>
            {{ "APPROVAL_MSG" | globalTranslate
            }}<strong>{{ "APPROVAL_MSG_1" | globalTranslate }}</strong>
          </p>
          <br />
        </div>
        } @if (coverageInfo.edgStatus === 'TN' && coverageInfo.cobSw !== 'Y') {
        <div>
          <p>
            {{ "END_MSG" | globalTranslate
            }}<strong>{{ "END_MSG_1" | globalTranslate }}</strong>
          </p>
          <br />
        </div>
        } @if (coverageInfo.edgStatus === 'DN' && coverageInfo.cobSw !== 'Y') {
        <div>
          <p>
            {{ "DENIAL_MSG" | globalTranslate
            }}<strong>{{ "DENIAL_MSG_1" | globalTranslate }}</strong>
          </p>
          <br />
        </div>
        } @if (coverageInfo.cobSw === 'Y') {
        <div>
          <p>
            {{ "OPEN_ON_APPEAL" | globalTranslate
            }}<strong>{{ "OPEN_ON_APPEAL_1" | globalTranslate }}</strong>
          </p>
          <br />
        </div>
        }
        <div>
          <small
            ><strong>{{ "COVERAGE_TYPE" | globalTranslate }}</strong></small
          >
          <p>{{ coverageInfo.highLevelProgram }}</p>
        </div>
        <div>
          <small
            ><strong>{{
              "COVERAGE_CASE_NUMBER" | globalTranslate
            }}</strong></small
          >
          <nh-popover
            class="ps-1"
            [content]="caseNumPop | globalTranslate"
          ></nh-popover>
          <p>{{ memberInfo.caseNum }}</p>
        </div>
        <div>
          <small
            ><strong>{{ "COVERAGE_STATUS" | globalTranslate }}</strong></small
          >
          @if (coverageInfo.cobSw === 'Y') {
          <nh-popover
            class="ps-1"
            [content]="coverageStatustooltip | globalTranslate"
          ></nh-popover>
          } @if (coverageInfo.edgStatus === 'TN' && coverageInfo.cobSw !== 'Y')
          {
          <p>{{ "COVERAGE_STATUS_TERMINATED" | globalTranslate }}</p>
          } @if (coverageInfo.edgStatus === 'AP' && coverageInfo.cobSw !== 'Y')
          {
          <p>{{ "COVERAGE_STATUS_APPROVED" | globalTranslate }}</p>
          } @if (coverageInfo.edgStatus === 'DN' && coverageInfo.cobSw !== 'Y')
          {
          <p>{{ "COVERAGE_STATUS_DENIED" | globalTranslate }}</p>
          } @if (coverageInfo.cobSw === 'Y') {
          <p>{{ "COVERAGE_STATUS_OPEN_ON_APPEAL" | globalTranslate }}</p>
          }
        </div>
        @if (coverageInfo.edgStatus === 'AP' || coverageInfo.edgStatus === 'TN'
        || coverageInfo.cobSw === 'Y') {
        <div>
          <small
            ><strong>{{
              "COVERAGE_BEGIN_DATE" | globalTranslate
            }}</strong></small
          >
          <p>{{ covBeginDate }}</p>
        </div>
        } @if (coverageInfo.edgStatus === 'DN' && applicationDate &&
        coverageInfo.cobSw !== 'Y') {
        <div>
          <small
            ><strong>{{
              "APPLICATION_BEGIN_DATE" | globalTranslate
            }}</strong></small
          >
          <p>{{ applicationDate }}</p>
        </div>
        } @if (coverageInfo.coverageEndDate && coverageInfo.edgStatus === 'TN'
        || coverageInfo.coverageEndDate && coverageInfo.cobSw === 'Y') {
        <div>
          <small
            ><strong>{{ "COVERAGE_END_DATE" | globalTranslate }}</strong></small
          >
          <p>{{ covEndDate }}</p>
        </div>
        } @if (coverageInfo?.kbPremiumResponse?.length) {
        <div>
          <div>
            <h2 class="section-header">{{ "KB" | globalTranslate }}</h2>
          </div>
          <hr />
          <div class="row">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ "PREMIUM_BEGIN_DATE" | globalTranslate }}</th>
                  <th>{{ "PREMIUM_END_DATE" | globalTranslate }}</th>
                  <th>{{ "INDIVIDUAL_PREMIUM_AMOUNT" | globalTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (item of coverageInfo.kbPremiumResponse; track item) {
                <tr>
                  <td>{{ item.premiumBeginDate }}</td>
                  <td>
                    {{
                      item.premiumEndDate
                        ? item.premiumEndDate
                        : ("ONGOING" | globalTranslate)
                    }}
                  </td>
                  <td>{{ item.premiumAmt }}</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        }<br />
        @if (coverageInfo.denialReasonResponse && coverageInfo.edgStatus ===
        'DN' && coverageInfo.cobSw !== 'Y') {
        <div>
          <small
            ><strong>{{ "DENIAL_RSN" | globalTranslate }}</strong></small
          ><br />
          @for (item of coverageInfo.denialReasonResponse; track item) {
          <div>
            @if (this.translateService.getDefaultLang() === 'en') {
            <div>
              <ol class="ps-0">
                <p>{{ item.denialReasonText | globalTranslate }}</p>
              </ol>
            </div>
            } @if (this.translateService.getDefaultLang() === 'sp') {
            <div>
              <ol class="ps-0">
                <p>{{ item.denialReasonTextES }}</p>
              </ol>
            </div>
            }
          </div>
          }
        </div>
        } @if (coverageInfo.terminationReasonResponse && coverageInfo.edgStatus
        === 'TN' && coverageInfo.cobSw !== 'Y') {
        <div>
          <small
            ><strong>{{
              "REASON_COVERAGE_END" | globalTranslate
            }}</strong></small
          ><br />
          @for (item of coverageInfo.terminationReasonResponse; track item) {
          <div>
            @if (this.translateService.getDefaultLang() === 'en') {
            <div>
              <ol class="ps-0">
                <p>{{ item.terminationReasonText | globalTranslate }}</p>
              </ol>
            </div>
            } @if (this.translateService.getDefaultLang() === 'sp') {
            <div>
              <ol class="ps-0">
                <p>{{ item.terminationReasonTextES }}</p>
              </ol>
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      } @if (appealSummary && appealSummary.length &&
      appealSummary[0].appealTypeResponse &&
      appealSummary[0].appealTypeResponse.length) {
      <div>
        <h2 class="section-header">
          {{ "APPEAL_INFORMATION" | globalTranslate }}
        </h2>
        <hr />
        @for (item of appealSummary[0].appealTypeResponse; track item) {
        <div>
          <div class="pt-3">
            <small
              ><strong>{{ "APPEAL_NUMBER" | globalTranslate }}</strong></small
            >
            <div>
              {{ item.appealNumber }}
            </div>
          </div>
          <div class="pt-3">
            <small
              ><strong>{{ "APPEAL_STATUS" | globalTranslate }}</strong></small
            >
            <div>
              {{ item.appealStatusDescription | globalTranslate }}
            </div>
          </div>
          @if (item.formatedHearingDate) {
          <div class="pt-3">
            <small
              ><strong>{{ "HEARING_INFO" | globalTranslate }}</strong></small
            >
            <div>
              <div>{{ item.formatedHearingTime }}</div>
              <div>{{ item.formatedHearingDate | date: "MM/dd/yyyy" }}</div>
              <div>{{ item.hearingTypeDescription | globalTranslate }}</div>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
      <br />
      @if (tplResponse && tplResponse.length) {
      <div>
        <h2 class="section-header">{{ "OTHER_COVERAGE" | globalTranslate }}</h2>
        <hr />
        <div>
          <small
            ><strong>{{
              "HEALTH_COVERAGE_TYPE" | globalTranslate
            }}</strong></small
          >
          @for (item of tplResponse; track item) {
          <div>
            {{ item.tplType }}
          </div>
          }
        </div>
        <div class="pt-3">
          <small
            ><strong>{{
              "HEALTH_INSURANCE_COMPANY_NAME" | globalTranslate
            }}</strong></small
          >
          @for (item of tplResponse; track item) {
          <div>
            {{ item.tplName }}
          </div>
          }
        </div>
        @for (item of tplResponse; track item) {
        <div class="pt-3">
          <div>
            <small
              ><strong>{{ "DATE_STARTED" | globalTranslate }}</strong></small
            >
            @if (item.tplCoverageBeginDate) {
            <div>
              {{ item.tplCoverageBeginDate }}
            </div>
            }
          </div>
        </div>
        } @for (item of tplResponse; track item) {
        <div class="pt-3">
          @if (item.tplCoverageEndDate) {
          <div>
            <small
              ><strong>{{ "DATE_ENDED" | globalTranslate }}</strong></small
            >
            <div>
              {{ item.tplCoverageEndDate }}
            </div>
          </div>
          }
        </div>
        }
      </div>
      } @if (healthPlanResponse && healthPlanResponse.length) {
      <div>
        <h2 class="section-header">
          {{ "HEALTH_PLAN_SECTION" | globalTranslate }}
        </h2>
        <hr />
        <div>
          {{ "HEALTH_PLAN_INFOTEXT" | globalTranslate }}
        </div>
        <br />
        @for (item of healthPlanResponse; track item) {
        <div>
          <div>
            <small
              ><strong>{{
                "HEALTH_PLAN_NAME" | globalTranslate
              }}</strong></small
            >
            <div>
              {{ item.providerName }}
            </div>
          </div>
          <div class="pt-3">
            <small
              ><strong>{{
                "HEALTH_PLAN_START_DATE" | globalTranslate
              }}</strong></small
            >
            <div>
              {{ item.startDate }}
            </div>
          </div>
          <div class="pt-3">
            <small
              ><strong>{{
                "HEALTH_PLAN_END_DATE" | globalTranslate
              }}</strong></small
            >
            <div>
              {{ item.endDate }}
            </div>
          </div>
          <br />
        </div>
        }
        <div>
          <br />
          {{ "HEALTH_PLAN_MORE_INFO" | globalTranslate }}
          <a
            target="_blank"
            href="https://www.tn.gov/tenncare/members-applicants/managed-care-organizations.html"
            >{{ "TENNCARE_WEBSITE" | globalTranslate }}</a
          >
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>